import { Injectable } from '@angular/core';
import { InterestAPIService } from '@app/domain/interest/api/interest-api.service';
import { Interest } from '@app/domain/interest/model/interest.model';
import { UserAPIService } from '@app/shared/api/user.api.service';
import { Globals } from '@app/shared/globals/globals';
import { NotifyUtils } from '@app/shared/utils/notify.utils';
import { Observable, firstValueFrom } from 'rxjs';
import { SettingsMessages } from '../locale/settings.messages';
import { InFlightRegistry } from '@app/shared/utils/in-flight-registry';

const WRITE_KEY = 'write';

@Injectable({
  providedIn: 'root'
})
export class SkillsBusinessService {

  // A write already in flight coalesces a duplicate call onto the same promise (see InFlightRegistry)
  // rather than rejecting it, which previously surfaced as an unhandled rejection (Sentry FRONTEND-3HT).
  private writes = new InFlightRegistry();

  constructor(
    private interestAPI: InterestAPIService,
    private userAPI: UserAPIService,
    private notifyUtils: NotifyUtils,
    public globals: Globals
  ) { }

  setSkills(skills: Interest[]): Promise<Interest[]> {
    return this.writes.run(WRITE_KEY, () =>
      firstValueFrom(this.userAPI.updateSkills(skills))
        .then(res => {
          this.notifyUtils.notify(SettingsMessages.SUCCESS_PROFILE_UPDATED);
          this.globals.user.skills = res.skills;

          return res.skills;
        })
    );
  }

  getSkillsForUserId(userId: number): Observable<Interest[]> {
    return this.interestAPI.getSkillsForUserId(userId);
  }
}
